/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { SocialShare, StoryElement } from "@quintype/components";
import { object, array, string, func } from "prop-types";

import MetypeCommentWrapper from "../../metype-comments";
import Demarcation from "../../atoms/demarcation";
import StoryMetaInfo from "../../molecules/story-meta-info";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import { fetchRelatedStories } from "../utils";
import StoryCard from "../story-card";
import StoryTag from "../story-tag";
import SideBar from "../side-bar";
import RelatedStories from "../related-stories";
import DfpAd from "../../dfp-ad/index";
import { storyShareClickHandler } from "../../utils";

import "./video.m.css";

function getPrimaryVideo(cards) {
  const headerVideo = [];

  cards.forEach(function(card) {
    card["story-elements"].forEach(function(element) {
      if (element["type"] === "youtube-video" || element["subtype"] === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });

  return headerVideo[0];
}

function getCards(story, primaryVideoID) {
  let storyCards = story.cards.map(card => {
    const newCard = Object.assign({}, card);
    let elements = card["story-elements"].filter(element => element.id !== primaryVideoID);
    newCard["story-elements"] = elements;
    return newCard;
  });
  story.cards = storyCards;
  return story;
}

class VideoStoryTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderMetype: false,
      showReadmore: {},
      wrapperClass: "",
      addReadmore: false,
      width: null,
      getTime: "121"
    };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
    // script to load the colombia ads

    fetchRelatedStories(this.props.story).then(relatedStories => {
      this.setState({ relatedStories });
    });

    this.setState({
      renderMetype: true,
      getTime: new Date()
        .getTime()
        .toString()
        .slice(-6)
    });
  }

  render() {
    const { trendingStories, collectionName, recentStories, config } = this.props;
    const story = Object.assign({}, this.props.story);
    const primaryVideo = getPrimaryVideo(story.cards);
    const storyProps = primaryVideo ? getCards(story, primaryVideo.id) : this.props.story;
    const publisherUrl = config["sketches-host"] || "https://www.freepressjournal.in";
    const colombiaAdStyle = {
      minHeight: "2px",
      width: "100%"
    };
    return (
      <React.Fragment>
        <div styleName="wrapper">
          {this.state.width <= 992 && (
            <div styleName="dfp-ad-300x100">
              <DfpAd adtype="rectangle_0_300x250" />
            </div>
          )}
          <div>
            <StoryMetaInfo story={story} />
            <div styleName="top-video">
              <StoryElement element={primaryVideo} story={this.props.story} externalLink={true} />
            </div>
            <div styleName="story-content">
              <div>
                <SocialShare
                  template={StickySocialShareTemplate}
                  title={story.headline}
                  url={story.slug}
                  color="#000"
                  sticky
                  onClick={storyShareClickHandler(story["story-content-id"], `${publisherUrl}/${story.slug}`)}
                />
              </div>
              <div styleName="video-story-content">
                <div ref={divElement => (this.divElement = divElement)}>
                  <div styleName="content-wrapper">
                    {storyProps.cards.map((card, index) => {
                      return (
                        <React.Fragment key={card.id}>
                          {index !== 0 &&
                            index % 3 === 0 && (
                              <div styleName="dfp-ad2-728x90">
                                <DfpAd adtype="banner_1_728x90" />
                              </div>
                            )}
                          {<StoryCard key={card.id} card={card} story={story} />}
                        </React.Fragment>
                      );
                    })}
                    <StoryTag tags={story.tags} />
                    {/* {this.state.renderMetype && <MetypeCommentWrapper story={story} />} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <SideBar stories={recentStories} collectionName={collectionName} id={story.id} />
          </div>
        </div>

        {this.state.width > 768 && (
            <div
              id={story.id}
              style={colombiaAdStyle}
              data-slot="319925"
              data-position={this.state.getTime}
              data-section="0"
              data-ua="D"
              className="colombia"
            />
          )}
          {this.state.width <= 768 && (
            <div
              id={story.id}
              style={colombiaAdStyle}
              data-slot="319929"
              data-position={this.state.getTime}
              data-section="0"
              data-ua="M"
              className="colombia"
            />
          )}

        <div styleName="related-stories">
          <RelatedStories relatedStories={trendingStories} collectionName="trending" />


        </div>
      </React.Fragment>
    );
  }
}

function VideoStory(props) {
  return (
    <div className="story-grid">
      <VideoStoryTemplate
        story={props.story}
        trendingStories={props.trendingStories}
        collectionName={props.collectionName}
        recentStories={props.recentStories}
        config={props.config}
      />
      <Demarcation />
    </div>
  );
}

VideoStoryTemplate.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  config: func
};

VideoStory.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  config: func
};

export default VideoStory;
